import React from "react";
import features from "../../assets/img/install.svg";

export default class Features extends React.Component {

    render() {
        return (
            <div className="container">
                <div className="section-title">
                    <h2>App Features</h2>
                    <p>Expense Genie provides user with the finest user interface which is not only clean and easy to
                        understand but also has great user experience.{" "} <br /> With Expense Genie in your phone, it
                        is easier than ever to keep track of all kinds of incomes and expenses.</p>
                </div>

                <div className="row no-gutters">
                    <div className="col-xl-7 d-flex align-items-stretch order-2 order-lg-1">
                        <div className="content d-flex flex-column justify-content-center">
                            <div className="row">
                                <div className="col-md-6 icon-box">
                                    <i className="bx bx-receipt"></i>
                                    <h3>Easily Differentiable Lists</h3>
                                    <p>We have made it super easy to access any expense/income transaction through our
                                        clean yet eye catchy user interface.</p>
                                </div>
                                <div className="col-md-6 icon-box">
                                    <i className="bx bx-cube-alt"></i>
                                    <h3>Daily Reminders</h3>
                                    <p>Everyday, your friend Genie will notify you to add your transactions, so you
                                        never miss it.</p>
                                </div>
                                <div className="col-md-6 icon-box">
                                    <i className="bx bx-category"></i>
                                    <h3>Category Wise Spending</h3>
                                    <p>User can able to view category wise spending and filter transactions by categories.</p>
                                </div>
                                <div className="col-md-6 icon-box">
                                    <i className="bx bx-shield"></i>
                                    <h3>Finding a Transaction</h3>
                                    <p>We provide easy filtering of income/expense transactions by various factors.</p>
                                </div>
                                <div className="col-md-6 icon-box">
                                    <i className="bx bx-atom"></i>
                                    <h3>Budget Setting</h3>
                                    <p>At Expense Genie, user can set monthly budget for maximum expenses to avoid over
                                        expenditure.</p>
                                </div>
                                <div className="col-md-6 icon-box">
                                    <i class='bx bx-doughnut-chart'></i>
                                    <h3>Insightful Analytics</h3>
                                    <p>You can see the insightful analytics to easily track and manage expenses.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="image col-xl-5 d-flex align-items-stretch justify-content-center order-1 order-lg-2">
                        <a href="https://storyset.com/user" target={'_blank'} rel="noreferrer">
                            <img src={features} width="600" height="600" className="img-fluid" alt="Feature Page Banner" />
                        </a>
                    </div>
                </div>
            </div>
        );
    }

}
